// =============================================================================
// CANVAS UTILS - Shared helpers for image generation
// =============================================================================

import { LOGO_PATH } from './config';

interface LoadLogoOptions {
  timeoutMs?: number;
  crossOrigin?: string | null;
}

/**
 * Load logo image with optional timeout and CORS settings
 */
export async function loadLogo({
  timeoutMs = 3000,
  crossOrigin = 'anonymous',
}: LoadLogoOptions = {}): Promise<HTMLImageElement | null> {
  return new Promise((resolve) => {
    const img = new Image();
    let resolved = false;

    if (crossOrigin) {
      img.crossOrigin = crossOrigin;
    }

    const timeout = setTimeout(() => {
      if (!resolved) {
        resolved = true;
        console.warn('Logo load timed out');
        resolve(null);
      }
    }, timeoutMs);

    img.onload = () => {
      if (resolved) return;
      resolved = true;
      clearTimeout(timeout);
      resolve(img);
    };

    img.onerror = () => {
      if (resolved) return;
      resolved = true;
      clearTimeout(timeout);
      console.warn('Failed to load logo');
      resolve(null);
    };

    img.src = LOGO_PATH;
  });
}
